import { render, staticRenderFns } from "./LectureResultSurvey.vue?vue&type=template&id=3722c1e2&"
import script from "./LectureResultSurvey.vue?vue&type=script&lang=ts&"
export * from "./LectureResultSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports